<template>
  <div class="form-group row">
    <div class="col-4"></div>
    <div class="col-6">
      <button class="btn btn-outline-primary btn-block" @click="submit()" :disabled="disabled">
        <i class="fa fa-floppy-o" aria-hidden="true"></i>
        <slot></slot>
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      disabled: {
        required: false,
        default: false,
        type: Boolean
      }
    },
    methods: {
      submit () {
        this.$emit('click')
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/utils/submit-field.vue